/**
 * Sistema de notificaciones (toasts) reutilizable.
 * Usa el Toaster de Fluent UI v9.
 *
 * Uso desde cualquier componente:
 *   const toast = useToast();
 *   toast.success("AFE creado");
 *   toast.error("Error al guardar", err.message);
 */

import {
  useToastController,
  Toast,
  ToastTitle,
  ToastBody,
  type ToastIntent,
} from "@fluentui/react-components";

export const TOASTER_ID = "pmis-toaster";

export function useToast() {
  const { dispatchToast } = useToastController(TOASTER_ID);

  function show(title: string, intent: ToastIntent, detail?: string, durationMs?: number) {
    dispatchToast(
      <Toast>
        <ToastTitle>{title}</ToastTitle>
        {detail && <ToastBody>{detail}</ToastBody>}
      </Toast>,
      {
        intent,
        timeout: durationMs ?? (intent === "error" ? 8000 : 4000),
      },
    );
  }

  return {
    success: (msg: string, detail?: string) => show(msg, "success", detail),
    error: (msg: string, detail?: string) => show(msg, "error", detail),
    warning: (msg: string, detail?: string) => show(msg, "warning", detail),
    info: (msg: string, detail?: string) => show(msg, "info", detail),
  };
}
